<div *ngIf="card" id='{{cardId}}' class="se-membership-card-container{{ fullWidth ? '--full-width' : '' }} se-block">
  <div class="se-membership-card-header">
    <div class="se-membership-card-org-avatar">
      <span class="se-membership-card-org-avatar__image">
        <se-avatar-group
          [se-data-avatars]="card.organizations"
          se-data-size="200"
          se-data-border="true"
          se-data-type="org">
        </se-avatar-group>
      </span>
      <span class="se-membership-card-org-avatar__title">{{ orgName }}
      </span>
    </div>
    <div class="se-membership-card-header__action" *ngIf="cardMenuItems.length">
      <se-menu-reference se-data-reference-id="{{menuActionId}}">
        <se-icon
          name="wallet"
          size="700"
          role="button"
          aria-label="Digital Wallet"></se-icon>
      </se-menu-reference>
      <se-menu
        role="dialog"
        se-data-reference-id="{{menuActionId}}"
        se-data-options="cardMenuOptions"
        se-data-container-id="{{cardId}}"></se-menu>
    </div>
  </div>
  <div class="se-membership-card-info">
    <div class="se-membership-card-info__text">
      <h2 class="se-membership-card-info__name">{{ (card.member.full_name || card.member.name) }}</h2>
      <p class="se-membership-card-info__number">{{ card.member.number }}</p>
    </div>
    <div class="se-membership-card-info__persona-avatar">
      <se-persona-avatar
        [se-data-identity]="(card.member.name || card.member.full_name)"
        [se-data-img-url]="card.member.image"
        se-data-size="500">
      </se-persona-avatar>
    </div>
  </div>
  <div *ngIf="singleMembership" class="se-membership-card-single-membership">
    <div class="se-membership-card-info__number">
      <p class="se-membership-card-info__key">Membership</p>
      <p class="se-membership-card-info__value">{{ singleMembership.name }}</p>
    </div>
    <div class="se-membership-card-info--multi-value">
      <div class="se-membership-card-info__dates" *ngIf="singleMembership.expiresAt">
        <p class="se-membership-card-info__key">Expiration</p>
        <p class="se-membership-card-info__value">{{ membershipCardService.formatDate(singleMembership.expiresAt) }}</p>
      </div>
      <div class="se-membership-card-info__status">
        <p class="se-membership-card-info__key">Status</p>
        <p class="se-membership-card-info__value">
          <se-tag
            class="se-tag--no-margin"
            se-data-color="{{ membershipCardService.statusColor(singleMembership) }}"
            se-data-value="{{ membershipCardService.statusLabel(singleMembership) }}">
          </se-tag>
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="multipleMemberships" class="se-membership-card-multiple-memberships">
    <div
      *ngFor="let membership of multipleMemberships"
      class="se-membership-card-info__membership"
      [ngClass]="{ 'se-membership-card-info__membership--highlight': membership.status === 'incomplete' }">
      <div class="se-membership-card-info__membership-primary">
        <div class="se-membership-card-info__membership-name">{{ membership.name }}</div>
        <div class="se-membership-card-info__membership-status">
          <se-tag-group>
            <se-tag
              se-data-color="{{ membershipCardService.statusColor(membership) }}"
              se-data-value="{{ membershipCardService.statusLabel(membership) }}">
            </se-tag>
          </se-tag-group>
        </div>
      </div>
      <div class="se-membership-card-info__membership-secondary">
        <a
          *ngIf="membership.eligibilityActionLink && membership.eligibilityActionLabel"
          class="se-membership-card-info__membership-link"
          href="{{membership.eligibilityActionLink}}">
          {{ membership.eligibilityActionLabel }}
        </a>
        <div
          *ngIf="(!membership.eligibilityActionLink || !membership.eligibilityActionLabel) && membership.effectiveAt && membership.expiresAt"
          class="se-membership-card-info__membership-details">
          {{ membershipCardService.expirationDescription(membership) }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="multipleMemberships && card.detailsLink" class="se-membership-card-footer">
    <div class="se-membership-card-footer__generic-link" *ngIf="card.detailsLink">
      <a href="{{ card.detailsLink }}">View Details</a>
    </div>
  </div>
</div>
